import { createSlice } from "@reduxjs/toolkit";
import { PoolsState } from "state/types";

const initialState: PoolsState = {
  isTxnPending: false,
  txnHash: undefined,
};

export const antePoolsSlice = createSlice({
  name: "Pools",
  initialState,
  reducers: {
    setIsTxnPending: (state, action) => {
      state.isTxnPending = action.payload;
    },
    setTxnHash: (state, action) => {
      state.txnHash = action.payload;
    },
  },
});

// Actions
export const { setIsTxnPending, setTxnHash } = antePoolsSlice.actions;

export default antePoolsSlice.reducer;
